import React, { useMemo, useRef } from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import CycleAttachmentTable, { CycleAttachmentModel } from '../../AppGrid/CycleAttachmentTable';


const CycleAttachmentForm = CycleAttachmentModel.createFormDialog();

const CycleAttachmentList = () => {
	const [searchParams] = useSearchParams()
	const gridRef = useRef()
	const AssociationId = searchParams.get('AssociationId');
	const AssociationTypeId = searchParams.get('AssociationTypeId');
	const AttachmentTypeId = searchParams.get('AttachmentTypeId');
	const Help = searchParams.get('Help');
	const isFromDCPL = !JSON.parse(searchParams.get('isFromScreen'));
	const [manualRefresh, setManualRefresh] = React.useState();
	const parentFilters = useMemo(() => {
		let filters = {};
		if (AssociationId) {
			filters.associationId = AssociationId;
		}
		if (AssociationTypeId) {
			filters.associationTypeId = AssociationTypeId;
		}
		filters.isFromDCPL = isFromDCPL;
		return filters;
	}, [AssociationId, AssociationTypeId, AttachmentTypeId, isFromDCPL]);

	return (
		<Grid container>
			<Grid size={12}>
				<Card sx={{ mb: 1, width: '100%' }}>
					<CardContent>
						<Grid container size={12}>
							<Grid size={{xs: 12, md: 4}} >
								<CycleAttachmentForm
									containerProps={{ elevation: 0 }}
									activeRecord={{
										id: AssociationId,
										record: {
											id: AssociationId,
											Help: Help,
											AssociationId,
											AssociationTypeId,
											AttachmentTypeId
										}
									}}
									onRecordSaved={(data, { resetForm }) => {
										gridRef.current.refresh()
										resetForm()
									}}
									initialValues={{ AssociationId, AssociationTypeId, AttachmentTypeId }}
									hideSubmit
									hideCancel
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
			<Grid size={12}>
				<CycleAttachmentTable parentFilters={parentFilters} tableRef={gridRef} manualRefresh={manualRefresh} />
			</Grid>
		</Grid>
	);

}

export default CycleAttachmentList